// Resolve image/video URL — Cloudinary (full https://) stays as-is,
// legacy local-disk paths get backend-URL prefix.
export function mediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}
